import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyCardAgents = (
  property: IPropertyDetailsResponse
) => {
  return property.agents.map(agent => agent.name).join(", ");
};
